import { http } from '../mock-http';
import mockResponse from './mock-getCurrentTicket';

export default {
  getCurrentTicket: () => http.get(mockResponse),
};
